import { IEquipment } from '@frontend/equipment/types';
import { IProduct } from '@frontend/product/types';

import { useScreen } from '../useScreen';

interface ViewProps {
    product?: IProduct;
    equipment?: IEquipment;
}

const useReviewResolve = (): ViewProps => {
    const { wizardData } = useScreen();
    const { product, equipment } = wizardData;
    return { product, equipment };
};

export default useReviewResolve;
